// extracted by mini-css-extract-plugin
export default {"detailCard":"index_detailCard__DEvVY","column":"index_column__vzTYh","label":"index_label__Qf0mE","value":"index_value__9Jgq+"};